import { render, staticRenderFns } from "./ReadOnlyEditor.vue?vue&type=template&id=67962a1a&"
import script from "./ReadOnlyEditor.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReadOnlyEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports